<template>
    <AffiliateLandingPage routePath="perks"></AffiliateLandingPage>
</template>
  
<script>
import AffiliateLandingPage from '@/components/Affiliate/AffiliateLandingPage.vue'

export default {
    components: {
        AffiliateLandingPage
    },
    name: 'PerksLandingPage'
}
</script>
  
<style></style>
  